import React from "react";
import DownloadRedirect from "../components/DownloadRedirect";
import { getDeviceType } from "../utils/appLinks";

// Direct visits use the early redirect in public/index.html. This page also
// handles client-side navigation and provides a link if navigation is blocked.
const DOWNLOAD_URLS = {
  android:
    "https://play.google.com/store/apps/details?id=com.mondowy_app_user&pcampaignid=web_share",
  ios: "https://apps.apple.com/us/app/mondoway/id6444758076",
  other: "https://mondoway.com/"
};

function DownloadUser({ openUrl }) {
  const destination = DOWNLOAD_URLS[getDeviceType()];

  return (
    <DownloadRedirect destination={destination} openUrl={openUrl} />
  );
}

export default DownloadUser;
